<template>
  <div class="search-page-wrapper">
  	<div class="search-page-header">
  		<div class="search-page-key">
  			<input v-model="key" val="" :placeholder="text.search_placeholder"/>
  		</div>
  	</div>
  	<div class="search-page-title">{{ text.search_title }}</div>
  	<div class="search-page-used-key">«{{ active_key }}»</div>
  	<div class="search-page-modes clearfix">
  		<div v-on:click="mode='journal'" class="search-page-mode" :class="{ active: mode == 'journal' }">{{ text.mode_journal }}</div>
  		<div v-if="show_norm" v-on:click="mode='norm'" class="search-page-mode" :class="{ active: mode == 'norm' }">{{ text.mode_norm }}</div>
  	</div>
  	<div v-if="totalCount && mode=='journal'" class="search-page-details" v-html="searchPageDetails"></div>
  	<!--<div v-if="mode=='journal'" class="search-page-periods clearfix">
  		<div class="search-page-periods-label">Показано за:</div>
  		<div v-on:click="period='all'" :class="{ active: period == 'all' }" class="search-page-period">весь час</div>
  		<div v-on:click="period='months'" :class="{ active: period == 'months' }"class="search-page-period">останні 3 місяці</div>
  		<div v-on:click="period='year'" :class="{ active: period == 'year' }" class="search-page-period">останній рік</div>
  	</div>-->

    <div v-if="mode=='norm' && show_norm" class="norm-filters clearfix">
      <select v-model="doc_status" class="norm-filter doc-status-filter">
        <option value="0">Статус документа</option>
        <option v-for="(doc_status_label, doc_status_id) in doc_statuses" :value="doc_status_id" v-html="doc_status_label"></option>
      </select>
      <input v-model="doc_number" class="norm-filter doc-number-filter" placeholder="Номер"/>
      <select v-model="doc_producer" class="norm-filter doc-producer-filter">
        <option value="0">{{ text.publisher }}</option>
        <option v-for="(doc_producer_label, doc_producer_id) in doc_producers" :value="doc_producer_id" v-html="doc_producer_label"></option>
      </select>
      <select v-model="doc_type" class="norm-filter doc-type-filter">
        <option value="0">Тип документа</option>
        <option v-for="doc_type in doc_types" :value="doc_type.id" v-html="doc_type.label"></option>
      </select>
      <div class="norm-filter date-filters-wrapper">
        {{ text.text_from }}&nbsp;&nbsp;&nbsp;&nbsp;<input v-model="date_from" class="date-from-filter" :placeholder="text.placeholder_date"/> {{ text.text_to }}&nbsp;&nbsp;&nbsp;<input v-model="date_to" class="date-to-filter" :placeholder="text.placeholder_date"/>
      </div>
    </div>

  	<div class="search-page-results">
      <norm-item v-if="mode=='norm' && show_norm" v-for="item in items" v-bind:key="item.id" v-bind:item="item"></norm-item>
      <article-item v-if="mode=='journal'" v-for="item in articles" v-bind:key="item.id" v-bind:item="item"></article-item>
  	</div>

  </div>
</template>

<script>

import NormItem from '../components/normItem.vue';
import ArticleItem from '../components/articleItem.vue';

export default {

  created () {

  },

  components: {
    'norm-item': NormItem,
    'article-item': ArticleItem,
  },

  data () {
    return {
      key: key,
      doc_status: 0,
      doc_number: '',
      doc_producer: 0,
      doc_type: 0,
      date_from: '',
      date_to: '',
      active_key: Drupal.t('не задано'),
      searchDelaytimer: null,
      journalName: journalName,
      requests: [],
      items: [],
      articles: [],
      regMatch: false,
      totalCount: 0,
      page: 0,
      is_loading: false,
      mode: mode === 'norm' ? 'norm' : 'journal',
      period: 'all', // all/months/year
      doc_types: doc_types,
      doc_producers: doc_producers,
      doc_statuses: doc_statuses,
      editionTextType: editionTextType,
      text: {
        search_placeholder: Drupal.t('Пошук'),
        search_title: Drupal.t('Результати пошуку:'),
        mode_journal: Drupal.t('У ' + editionTextType), // Drupal.t('У газеті'); Drupal.t('У журналі');
        mode_norm: Drupal.t('Правова база'),
        publisher: Drupal.t('Видавець'),
        placeholder_date: Drupal.t('дд.мм.рррр'),
        text_from: Drupal.t('Прийнятий з'),
        text_to: Drupal.t('по'),
        from: Drupal.t('від')
      },
      show_norm: show_norm
    }
  },

  computed: {

    searchPageDetails () {
      // Drupal.t('У газеті знайдено @totalCount статей', {'@totalCount': this.totalCount});
      // Drupal.t('У журналі знайдено @totalCount статей', {'@totalCount': this.totalCount});
      return Drupal.t('У '+ this.editionTextType +' знайдено @totalCount статей', {'@totalCount': this.totalCount});
    },

  },

  watch: {

    key () {
      this.resetSearch();
      this.initSearch();
    },

    doc_number () {
      this.resetSearch();
      this.initSearch();
    },

    doc_status () {
      this.resetSearch();
      this.executeSearch();
    },

    doc_producer () {
      this.resetSearch();
      this.executeSearch();
    },

    mode () {
      this.resetSearch();
      this.executeSearch();
    },

    doc_type () {
      this.resetSearch();
      this.executeSearch();
    },

    date_from () {
      this.resetSearch();
      this.executeSearch();
    },

    date_to () {
      this.resetSearch();
      this.executeSearch();
    },

  },

  mounted () {
    this.initSearch();

    var triggerHeight = 500;
    var $itemsView = $('.search-page-results');
    var $window = $(window);
    var itemsViewTop = $itemsView.offset().top;

    $(window).scroll( e => {
      var itemsViewheight = $itemsView.height();
      var itemsViewBottom = $itemsView.height() + itemsViewTop;
      var windowHeight = $window.height();
      var scrollBottom = $window.scrollTop() + windowHeight;

      if ( itemsViewBottom - scrollBottom < triggerHeight ) {


        if ( !this.is_loading && this.totalCount > this.items.length && this.mode == 'norm' ) {
          this.page = this.page + 1;
          this.executeSearch();
        }

        if ( !this.is_loading && this.totalCount > this.articles.length && this.mode == 'journal' ) {
          this.page = this.page + 1;
          this.executeSearch();
        }


      }

    });

  },

  methods: {

    resetSearch () {
      this.page = 0;
      this.articles = [];
      this.items = [];
    },

    initSearch() {
      this.page = 0;
      this.articles = [];
      this.items = [];
      clearTimeout(this.searchDelaytimer);
      this.searchDelaytimer = setTimeout ( () => { this.executeSearch() }, 500);
    },

    buildRegMatch( filters ) {

      var regMatch = false;
      if ( filters.keys_highlight && filters.keys_highlight.length || filters.keys_search && filters.keys_search.length ) {
          var keys = _.map(filters.keys_highlight, function(key){
          key = key.replace('/', '\\/').replace('.', '\\.').replace(',', '\\,').replace('-', '\\-');
          return key;
        });
        regMatch = _.sortBy(_.uniq(filters.keys_search.concat(keys)), function(key){ return -key.length}).join('|');
      }

      return regMatch;

    },

    highlight ( str ) {

      if ( this.regMatch && str && str.length ) {
        str = str.replace(new RegExp(this.regMatch, 'gi'), function(val){
          if ( val ) {
            return '<span class="key-highlight">' + val + '</span>';
          }
        });
      }

      return str;

    },

    executeSearch() {

      var key = this.key;
      var self = this;
      this.is_loading = true;

      if ( this.mode == 'norm') {
        var params = {
          page: this.page,
          filters: {
            key: key,
            doc_type: this.doc_type ? this.doc_type : null,
            status: this.doc_status ? this.doc_status : null,
            doc_producer: this.doc_producer ? this.doc_producer : null,
            number: this.doc_number.length ? this.doc_number : null,
            date_from: this.date_from.length==10 ? this.date_from : null,
            date_to: this.date_to.length==10 ? this.date_to : null,
          }
        }

        this.sendApiRequest('getNormList', params, (data) => {
          this.regMatch = this.buildRegMatch(data.filters);
          _.each(data.list, (item) => this.items.push(item));
          this.totalCount = data.totalCount;
          this.active_key = this.key.length ? this.key : Drupal.t('не задано');
          this.is_loading = false;
          console.log(data);
        });
      } else {
        var params = {
          page: this.page,
          filters: {
            key: key,
            date_from: this.date_from.length==10 ? this.date_from : null,
            date_to: this.date_to.length==10 ? this.date_to : null,
          }
        }

        this.sendRequest('getArticlesList', params, (data) => {
          this.regMatch = this.buildRegMatch(data.filters);
          _.each(data.list, (article) => this.articles.push(article));
          this.totalCount = data.totalCount;
          this.active_key = this.key.length ? this.key : Drupal.t('не задано');
          this.is_loading = false;
          console.log(data);
        });
      }

    },

    sendApiRequest (command, params, callback) {

      var formdata = new FormData();
      var requests = this.requests;

      if ( params.file ) {
        formdata.append('file', params.file);
        delete params.file;
      }

      formdata.append('command', command);
      formdata.append('params', JSON.stringify(params));

      if ( command == 'getNormList' ) {
        _.each(requests, function(request) {
          if ( request.command == command ) {
            request.id.abort();
          }
        });
      }

      requests.push({
        id: $.ajax({
          url: '/request-api',
          data: formdata,
          processData: false,
          contentType: false,
          method: 'POST',
          success: function ( response ) {
            if ( response && response.error === 0 ) {
              callback ( response.data.data );
            } else {
              console.info(response.error, response.errorText);
            }
          }
        }),
        command: command
      })

    },

    sendRequest (command, params, callback) {

      var formdata = new FormData();
      var requests = this.requests;

      if ( params.file ) {
        formdata.append('file', params.file);
        delete params.file;
      }

      formdata.append('command', command);
      formdata.append('params', JSON.stringify(params));

      if ( command == 'getArticlesList' ) {
        _.each(requests, function(request) {
          if ( request.command == command ) {
            request.id.abort();
          }
        });
      }

      requests.push({
        id: $.ajax({
          url: '/request',
          data: formdata,
          processData: false,
          contentType: false,
          method: 'POST',
          success: function ( response ) {
            if ( response && response.error === 0 ) {
              callback ( response.data );
            } else {
              console.info(response.error, response.errorText);
            }
          }
        }),
        command: command
      })

    },

    updateItems(page, needScroll, resetFilters) {

      this.$http.post('/request', {
        page: page,
        key: ''
      }, {
        emulateJSON: true
      }).then((response) => {
        var json = response.data;
      });

    }

  }

}

</script>
